export enum AVariableContext {
    Styles = 0,
    Database = 1,
}